import './App.css';
import { forwardRef, useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from "react-router";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";

import TbPw from './silos/TbPW.js'
import TbTR1 from './silos/TbTR1.js';
import TbWC from './silos/TbWC.js';
import TbSC from './silos/TbSC.js';
import TbSM from './silos/TbSM.js';
import TbCS from './silos/TbCS.js';
import TbCW from './silos/TbCW.js';
import TbRM from './silos/TbRM.js';
import TbWC17 from './silos/TbWC17.js';

function App() {
  let { datehour, hour } = useParams();
  const [data, setData] = useState({'datetime': getDatetime()});
  const [datetime, setDatetime] = useState(data.datetime);
  const apiUrl = useRef(getApiUrl(datehour, hour));
  const intervalId = useRef(null); 
  const intervals = useRef({live: 0.5, past: 30});

  const navigate = useNavigate();

  useEffect(() => {
    debug("******* First load *******");
    document.title = 'Silos Inventory';
    startAutoUpdate(getUpdateInverval());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  function startAutoUpdate(min, au) {
    debug("min: "+min);
    clearInterval(intervalId.current);
    loadData(au).catch(console.error);
    intervalId.current = setInterval(() => {
      loadData().catch(console.error);
    }, min*60*1000);
  }

  function debug(msg) {
    if (process.env.NODE_ENV === "development") {
      console.log(msg);
    }
  }

  async function loadData(au) {
    debug("******* loadData *******");
    if (au !== undefined) apiUrl.current = au;
    const baseUrl = "/api/";
    debug(baseUrl + apiUrl.current);
    const response = await axios.get(baseUrl + apiUrl.current);
    let json = await response.data;
    debug(json);
    if (json === '{}') {
      console.log("INVALID DATE");
      setData({datetime: new Date()});
      return;
    }
    let retData = JSON.parse(json);
    debug(retData);
    setData(retData);
    setDatetime(new Date(retData.datetime));
  }
  const gotoHome = () => {
    navigate("/");
    startAutoUpdate(intervals.current.live, "last");
  }
  const goto2am = () => {
    let au = getApiUrl(undefined, 2);
    debug("goto2am: "+au);
    navigate("/h/2");
    startAutoUpdate(intervals.current.past, au);
  }
  const gotoDateHour = (dt) => {
    debug("******* gotoDateHour *******");
    let urlTo = getDateUrl(dt);
    debug([dt, urlTo]);
    navigate("/"+urlTo);
    startAutoUpdate(intervals.current.past, urlTo);
  }

  const DateButton = forwardRef(
    ({value, onClick, className }, ref) => (
      <button className={className} onClick={onClick} ref={ref}>
        {value}
      </button>
    )
  );

  function getUpdateInverval() {
    if (datehour !== undefined | hour !== undefined) return intervals.current.past;
    return intervals.current.live;
  }

  function getApiUrl(dh, h){
    let url = "last";
    if (dh !== undefined) {
      url = dh;
    }
    if (h !== undefined) {
      let dt = new Date();
      url = getDateUrl(dt).slice(0, 11) + ("0" + h).slice(-2) + ":00";
    }
    return url;
  }

  function getDateUrl(dt){
    let d = ("0"+dt.getDate()).slice(-2);
    let m = ("0"+(dt.getMonth()+1)).slice(-2);
    let y = dt.getFullYear();
    let h = ("0" + dt.getHours()).slice(-2);
    let mn = ("0" + dt.getMinutes()).slice(-2);
    let url = y + "-" + m + "-" + d + "T" + h + ":" + mn;
    return url;
  }

  function getDatetime(){
    let apiUrl = getApiUrl(datehour, hour);
    debug("getDatetime: "+apiUrl + " datehour: " + datehour + " hour: " + hour);
    return apiUrl === "last" ? new Date() : new Date(apiUrl);
  }

  
  return (
    <div className="container py-3">
        <header>
          <div className="fs-4 d-flex flex-column flex-md-row align-items-center pb-3 mb-4 border-bottom">
            <div className="fs-4 row align-items-start g-2">
              <div className="col-md-auto">Silos Inventory</div>
              <div className="col-md-auto"> 
                <DatePicker selected={datetime} maxDate={new Date()} onChange={(date) => {setDatetime(date);gotoDateHour(date);}} 
                  showTimeSelect dateFormat="MM/dd/yyyy h:mm aa" customInput={<DateButton className="btn btn-outline-primary btn-sm" />} />
              </div>
              <div className="col-md-auto"><button type="button" className="btn btn-outline-secondary btn-sm" onClick={goto2am}>2 AM</button></div>
              <div className="col-md-auto"><button type="button" className="btn btn-outline-secondary btn-sm" onClick={gotoHome} hidden={(datehour === undefined & hour === undefined)}>Current</button></div>
            </div>
            <div className="d-inline-flex mt-2 mt-md-0 ms-md-auto">
            </div>
          </div>
        </header>
        <main>
          <div className="row row-cols-1 row-cols-md-3 mb-3 text-center">
            <div className="col">
              <TbRM data={{data}} />
              <TbCW data={{data}} />
              <TbCS data={{data}} />
            </div>
            <div className="col">
              <TbSM data={{data}} />
              <TbSC data={{data}} />
              <TbWC data={{data}} />
              </div>
            <div className="col">
              <TbTR1 data={{data}} />
              <TbPw data={{data}} />
              <TbWC17 data={{data}} />
              </div>
          </div>
          <div className={process.env.NODE_ENV === 'production' ? 'invisible' : 'blockquote-footer'}>{process.env.NODE_ENV}</div>
        </main>
    </div>
  );
  
}

export default App;
